import { useState } from 'react';
import { useLocalStorage } from './useLocalStorage';

export const useFavorites = () => {
    const [favorites, setFavorites] = useLocalStorage('favorites', []);

    const addFavorite = (titleId) => {
        setFavorites([titleId, ...favorites]);
    };

    const removeFavorite = (titleId) => {
        setFavorites(favorites.filter((favorite) => favorite !== titleId));
    };

    return [favorites, addFavorite, removeFavorite];
};

export const useIsFavorite = (titleId) => {
    const [favorites] = useLocalStorage('favorites', []);
    const [isFavorite, setIsFavorite] = useState(favorites.some((favorite) => favorite === titleId));

    return [isFavorite, setIsFavorite];
};
